"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("../icon/Icon"));

var _Pagination = require("./Pagination.style");

var _Typography = _interopRequireDefault(require("../typography/Typography"));

var _excluded = ["totalRecords", "perPage", "handlePagination", "activePageNumber"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var renderPages = function renderPages(currentIndex, arr) {
  var length = arr.length;

  if (arr.length >= 8) {
    if (currentIndex <= 4) {
      return [1, 2, 3, 4, '...', arr[length - 1]];
    } else if (currentIndex >= 5 && currentIndex <= arr.length - 4) {
      return [1, '...', currentIndex - 1, currentIndex, currentIndex + 1, '...', arr[length - 1]];
    } else {
      return [1, '...', arr[length - 4], arr[length - 3], arr[length - 2], arr[length - 1]];
    }
  } else {
    return arr;
  }
};

var Pagination = function Pagination(_ref) {
  var totalRecords = _ref.totalRecords,
      perPage = _ref.perPage,
      handlePagination = _ref.handlePagination,
      activePageNumber = _ref.activePageNumber,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var _useState = (0, _react.useState)(activePageNumber),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      currentIndex = _useState2[0],
      setCurrentIndex = _useState2[1];

  (0, _react.useEffect)(function () {
    setCurrentIndex(activePageNumber);
  }, [activePageNumber]);
  var indexArray = (0, _react.useMemo)(function () {
    if (perPage > 0 && totalRecords > 0) {
      var totalPages = Math.ceil(totalRecords / perPage);
      return Array.from({
        length: totalPages
      }).map(function (_, i) {
        return i + 1;
      });
    } else {
      return [];
    }
  }, [totalRecords, perPage]);

  var _useState3 = (0, _react.useState)([]),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      showArray = _useState4[0],
      setShowArray = _useState4[1];

  var handlePageClick = function handlePageClick(val) {
    setCurrentIndex(val);
    handlePagination(val);
  };

  (0, _react.useEffect)(function () {
    var pages = renderPages(currentIndex, indexArray);
    setShowArray(pages);
    return function () {};
  }, [perPage, currentIndex, totalRecords, indexArray]);

  var handleNextClick = function handleNextClick() {
    if (currentIndex + 1 <= indexArray[indexArray.length - 1]) {
      setCurrentIndex(function (i) {
        return i + 1;
      });
      handlePagination(currentIndex + 1);
    }
  };

  var handlePreviousClick = function handlePreviousClick() {
    if (currentIndex - 1 >= indexArray[0]) {
      setCurrentIndex(function (i) {
        return i - 1;
      });
      handlePagination(currentIndex - 1);
    }
  };

  if (indexArray.length === 0) {
    return null;
  }

  var renderPrevNextButton = function renderPrevNextButton() {
    var isDisabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var type = arguments.length > 1 ? arguments[1] : undefined;
    var iconSize = 20;
    var iconFill = isDisabled ? '#AAA' : '#0A0A0A';
    return /*#__PURE__*/_react["default"].createElement(_Pagination.PrevNextWrapper, {
      className: isDisabled ? 'disabled' : '',
      onClick: function onClick() {
        if (!isDisabled) {
          type === 'prev' ? handlePreviousClick() : handleNextClick();
        }
      }
    }, type === 'prev' && /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      iconName: "ChevronLeft",
      size: iconSize,
      fill: iconFill
    }), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
      textType: "body",
      size: "S"
    }, type === 'prev' ? 'Prev' : 'Next'), type !== 'prev' && /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      iconName: "ChevronRight",
      size: iconSize,
      fill: iconFill
    }));
  };

  return /*#__PURE__*/_react["default"].createElement(_Pagination.StyledPagination, props, renderPrevNextButton(currentIndex === indexArray[0], 'prev'), /*#__PURE__*/_react["default"].createElement(_Pagination.StyledPages, null, showArray.map(function (pageNum, i) {
    return /*#__PURE__*/_react["default"].createElement(_Pagination.StyledPageNumber, {
      key: i,
      className: currentIndex === pageNum ? 'active' : '',
      onClick: function onClick() {
        if (currentIndex !== pageNum) {
          handlePageClick(pageNum);
        }
      }
    }, pageNum);
  })), renderPrevNextButton(currentIndex === indexArray[indexArray.length - 1], 'next'));
};

Pagination.defaultProps = {
  handlePagination: function handlePagination() {},
  activePageNumber: 1
};
Pagination.propTypes = {
  totalRecords: _propTypes["default"].number.isRequired,
  perPage: _propTypes["default"].number.isRequired,
  handlePagination: _propTypes["default"].func.isRequired,
  activePageNumber: _propTypes["default"].number
};
var _default = Pagination;
exports["default"] = _default;